export default __webpack_public_path__ + "static/media/face-id.edfc2b81.svg";